module.exports = __webpack_public_path__ + "static/img/brand-02.d2700c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand-02.png
// module id = Xl8I
// module chunks = 1